import { render, staticRenderFns } from "./StatusWf.vue?vue&type=template&id=18856848&scoped=true"
import script from "./StatusWf.vue?vue&type=script&lang=js"
export * from "./StatusWf.vue?vue&type=script&lang=js"
import style0 from "./StatusWf.vue?vue&type=style&index=0&id=18856848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18856848",
  null
  
)

export default component.exports